export enum QUERIES {
    GET_SUPPORTED_LANGUAGES = "GET_SUPPORTED_LANGUAGES",
    GET_TRANSLATION = "GET_TRANSLATION"
}